module.exports = __webpack_public_path__ + "static/media/16_l_Layer7_9.9_36.94.6f6af7d9.png";